import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function PolicyModal({
  title,
  onClose,
  children
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-69">
      <div className="bg-cream text-brown rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-70">
        <div className="sticky top-0 bg-cream rounded-t-2xl border-b border-brown/10 px-6 py-4 flex items-center justify-between" data-id="element-71">
          <h2 className="font-serif text-xl text-brown" data-id="element-72">{title}</h2>
          <button onClick={onClose} className="p-1.5 rounded-full hover:bg-brown/10 transition-colors" aria-label="Cerrar" data-id="element-73">
            <XIcon className="w-5 h-5 text-brown" data-id="element-74" />
          </button>
        </div>
        <div className="px-6 py-6 text-sm leading-relaxed space-y-4 text-brown/80" data-id="element-75">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-brown text-cream/70 py-12 px-6 text-center" data-id="element-76">
        <div className="max-w-4xl mx-auto" data-id="element-77">
          <p className="text-2xl mb-6" data-id="element-78">🌿</p>
          <h3 className="font-serif text-xl text-cream mb-6" data-id="element-79">
            La Botica de la Abuela Moderna
          </h3>

          <div className="text-sm space-y-4 mb-8 max-w-2xl mx-auto opacity-80" data-id="element-80">
            <p data-id="element-81">
              Descargo de responsabilidad: La información contenida en este
              libro es únicamente para fines educativos e informativos. No
              pretende sustituir el consejo, diagnóstico o tratamiento médico
              profesional.
            </p>
            <p data-id="element-82">
              Siempre busque el consejo de su médico u otro proveedor de salud
              calificado con cualquier pregunta que pueda tener sobre una
              condición médica.
            </p>
          </div>

          <div className="flex items-center justify-center gap-6 mb-8 text-sm" data-id="element-83">
            <button onClick={() => setOpenModal('privacy')} className="underline underline-offset-2 hover:text-cream transition-colors" data-id="element-84">
              Política de Privacidad
            </button>
            <span className="text-cream/30" data-id="element-85">|</span>
            <button onClick={() => setOpenModal('terms')} className="underline underline-offset-2 hover:text-cream transition-colors" data-id="element-86">
              Términos y Condiciones
            </button>
          </div>

          <div className="border-t border-cream/10 pt-8 text-sm" data-id="element-87">
            <p data-id="element-88">
              &copy; {new Date().getFullYear()} La Botica de la Abuela Moderna.
              Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {openModal === 'privacy' && <PolicyModal title="Política de Privacidad" onClose={() => setOpenModal(null)} data-id="element-89">
          <p data-id="element-90">
            <strong data-id="element-91">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-92">
            En La Botica de la Abuela Moderna, respetamos su privacidad y nos
            comprometemos a proteger su información personal. Esta política
            describe cómo recopilamos, usamos y protegemos sus datos.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-93">
            Información que recopilamos
          </h3>
          <p data-id="element-94">
            Recopilamos información que usted nos proporciona directamente, como
            su nombre y dirección de correo electrónico al realizar una compra.
            También podemos recopilar información de uso del sitio de forma
            anónima para mejorar nuestros servicios.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-95">
            Uso de la información
          </h3>
          <p data-id="element-96">
            Utilizamos su información para procesar pedidos, enviar
            comunicaciones relacionadas con su compra y mejorar nuestros
            productos y servicios. No vendemos ni compartimos su información
            personal con terceros con fines de marketing.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-97">
            Seguridad
          </h3>
          <p data-id="element-98">
            Implementamos medidas de seguridad razonables para proteger su
            información personal contra acceso no autorizado, alteración o
            destrucción.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-99">
            Sus derechos
          </h3>
          <p data-id="element-100">
            Usted tiene derecho a acceder, corregir o eliminar su información
            personal en cualquier momento. Para ejercer estos derechos, puede
            comunicarse con nosotros a través de los canales disponibles.
          </p>
        </PolicyModal>}

      {openModal === 'terms' && <PolicyModal title="Términos y Condiciones" onClose={() => setOpenModal(null)} data-id="element-101">
          <p data-id="element-102">
            <strong data-id="element-103">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-104">
            Al acceder y utilizar este sitio web y adquirir nuestros productos,
            usted acepta cumplir con estos términos y condiciones.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-105">
            Productos digitales
          </h3>
          <p data-id="element-106">
            Nuestros productos son de naturaleza digital y se entregan
            electrónicamente. Una vez completada la compra, recibirá acceso
            inmediato al contenido adquirido.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-107">
            Uso permitido
          </h3>
          <p data-id="element-108">
            El contenido adquirido es para uso personal y no comercial. Queda
            prohibida la reproducción, distribución o reventa del material sin
            autorización expresa.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-109">
            Política de reembolso
          </h3>
          <p data-id="element-110">
            Ofrecemos una garantía de satisfacción. Si no está satisfecho con su
            compra, puede solicitar un reembolso dentro del período establecido
            en nuestra garantía.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-111">
            Descargo de responsabilidad
          </h3>
          <p data-id="element-112">
            La información proporcionada en nuestros productos es únicamente
            para fines educativos e informativos. No constituye consejo médico
            profesional y no debe utilizarse como sustituto de una consulta
            médica.
          </p>
          <h3 className="font-serif text-base text-brown font-semibold pt-2" data-id="element-113">
            Modificaciones
          </h3>
          <p data-id="element-114">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación en este sitio.
          </p>
        </PolicyModal>}
    </>;
}